import Modules from 'application/modules'
import authService from 'core/auth/auth-service'

export function isSU(moduleName: Modules) {
  const currentUser = authService.getCurrentUser()
  const currentOpco = authService.getCurrentOpco() || ''

  return currentUser.groups.findIndex(group =>
    group.moduleName === moduleName &&
    group.role === 'su' &&
    group.opco === currentOpco
  ) >= 0
}

export function getACLDataFilter(moduleName: Modules, dataForOU: Array<string>, dataForSU: Array<string>) {
  if (isSU(moduleName)) {
    return [...dataForOU, ...dataForSU]
  }

  return dataForOU
}

export function getModules() {
  const currentUser = authService.getCurrentUser()
  const currentOpco = authService.getCurrentOpco() || ''

  return {
    opco: currentOpco,
    ACL: currentUser.groups.filter(group => group.opco === currentOpco)
  }
}